import styled from 'styled-components';

export const StyledBanner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.6rem;
  min-height: 55.5rem;
  padding: 3rem 1.8rem 18rem;
  position: relative;
  overflow: hidden;
  z-index: 0;

  &::before {
    content: '';
    position: absolute;
    left: -16.8rem;
    top: -6.2rem;
    width: 43.8rem;
    height: 26.8rem;
    border-radius: 86.8rem;
    background: radial-gradient(50% 50% at 50% 50%, #0B563F 0%, rgba(21, 28, 43, 0.00) 100%);
    pointer-events: none;
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;
    right: -9.2rem;
    bottom: -8.2rem;
    width: 43.8rem;
    height: 26.8rem;
    border-radius: 86.8rem;
    background: radial-gradient(50% 50% at 50% 50%, #0B563F 0%, rgba(21, 28, 43, 0.00) 100%);
    pointer-events: none;
    z-index: 1;
  }

  @media screen and (min-width: 576px) {
    min-height: 37.7rem;
    padding: 4.6rem;
  }

  & > div {
    z-index: 10;
  }
`;

export const StyledTitle = styled.h2`
  color: ${({ theme }) => theme.colors.text.main};
  letter-spacing: -0.96px;
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  margin-bottom: 0rem;
  text-transform: uppercase;

  font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
  text-align: left;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  @media screen and (max-width: 576px) {
    max-width: 100%;
  }
`;

export const StyledSubTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
  margin-bottom: 0rem;

  text-align: left;
  font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  max-width: 45.1rem;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
    font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  }

  @media screen and (max-width: 576px) {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    line-height: 2rem;
    max-width: 100%;
  }
`;

export const StyledSubTitleAlt = styled(StyledSubTitle)`
  font-size: ${({ theme }) => theme.fonts.sizes.large};
  line-height: 3rem;
  max-width: 100%;

  @media screen and (max-width: 576px) {
    font-size: ${({ theme }) => theme.fonts.sizes.medium};
    line-height: 2.3rem;
  }
`;

export const StyledButtons = styled.div`
  display: flex;
  gap: 1.6rem;
`;

export const StyledCountdownContainer = styled.div`
  padding: 0.8rem 0rem 0rem;
`;

export const StyledRiveAnimation = styled.div`
  position: absolute;
  z-index: 1;

  width: 27.9rem;
  height: 27.9rem;
  bottom: 0;
  right: 2.9rem;
  transform: none;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    width: 30rem;
    right: 2.9rem;
    transform: none;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 27rem;
    right: 3rem;
    transform: none;
  }

  @media screen and (max-width: 576px) {
    width: 22.2rem;
    right: 50%;
    transform: translateX(50%);
  }
`;
